import { useEffect, useState } from "react";

// Portrait phones show the list only — the map would be a useless sliver. The
// map is UNMOUNTED rather than hidden with CSS, because a Leaflet map in a
// zero-sized container throws on flyTo.
const QUERY = "(max-width: 900px) and (orientation: portrait)";

export function useMapVisible() {
  const [visible, setVisible] = useState(() =>
    typeof window === "undefined" ? true : !window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setVisible(!e.matches);
    mql.addEventListener("change", onChange);
    setVisible(!mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return visible;
}
